import { FunctionComponent } from 'react'
import {
  Box,
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Button,
} from '@mui/material'
import { Cached, ExpandMore, Search } from '@mui/icons-material'
import styled from '@emotion/styled'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const StyledMenuItem = styled(MenuItem)({
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#8a94a6',
  background: '#fff',
  padding: '14px 16px',
  '&:hover': {
    background: 'rgba(3, 34, 76, 0.12)',
  },
})

const StyledButton = styled(Button)({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '4px',
  height: '48px',
  padding: '14px',
  textDecoration: 'none',
  transition: 'all 0.4s ease 0s',
  '& svg': {
    color: '#fff',
    fontSize: '20px',
  },
})

interface Props {
  setFilters: (values: { orgName: string; year: string }) => void
}

export type ProcurementFiltersType = {
  orgName: string
  year: string
}

export const PurchasePlansFilters: FunctionComponent<Props> = ({ setFilters }) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<{
    orgName: string
    year: string
  }>({
    defaultValues: {
      orgName: '',
      year: '2024',
    },
  })
  const { t } = useTranslation()

  const onSubmit = (values: ProcurementFiltersType) => {
    setFilters(values)
  }

  const handleReset = () => {
    reset()
    setFilters({ orgName: '', year: '2024' })
  }
  return (
    <>
      <form id="purchase-plan-filter-form" onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            margin: '32px 0',
            position: 'relative',
          }}
        >
          <Grid
            container
            justifyContent="space-between"
            rowGap="10px"
            columnGap={{ xs: 0, md: '10px' }}
            sx={{
              padding: '20px',
              border: '1px solid #e1e4e8',
              borderRadius: '4px',
            }}
          >
            <Grid item xs={12} md={'auto'}>
              <FormControl fullWidth>
                <Controller
                  name="year"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      error={!!errors.year}
                      IconComponent={() => (
                        <ExpandMore
                          sx={{
                            fontSize: '24px',
                            color: 'rgb(3, 34, 76)',
                            marginRight: '16px',
                          }}
                        />
                      )}
                      sx={{
                        background: 'rgba(3, 34, 76, 0.12)',
                        color: 'rgb(3, 34, 76)',
                      }}
                      MenuProps={{
                        sx: {
                          '& .Mui-selected': {
                            backgroundColor: 'rgba(3, 34, 76, 0.12)',
                            color: '#000',
                          },
                          '& .Mui-focusVisible': {
                            background: '#fff !important',
                            ':hover': {
                              backgroundColor: 'rgba(3, 34, 76, 0.12) !important',
                            },
                          },
                        },
                      }}
                    >
                      <StyledMenuItem value={'2021'}>2021</StyledMenuItem>
                      <StyledMenuItem value={'2022'}>2022</StyledMenuItem>
                      <StyledMenuItem value={'2023'}>2023</StyledMenuItem>
                      <StyledMenuItem value={'2024'}>2024</StyledMenuItem>
                      <StyledMenuItem value={'2025'}>2025</StyledMenuItem>
                      <StyledMenuItem value={'2026'}>2026</StyledMenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
            <Grid
              item
              xs={9}
              md={'auto'}
              sx={{
                flexGrow: '1 !important',
              }}
            >
              <TextField
                id="search"
                placeholder={t('tender-organization-name')}
                variant="outlined"
                fullWidth
                sx={{
                  maxHeight: '48px',
                  '& .MuiInputBase-input': {},
                  '& fieldset': {},
                }}
                {...register('orgName')}
              />
            </Grid>
            <Grid item xs={3} md={'auto'}>
              <Box display="flex" justifyContent="flex-end" gap="10px">
                <StyledButton
                  sx={{
                    background: 'rgb(122, 127, 126)',
                    '&:hover': {
                      background: 'rgb(135, 141, 140)',
                    },
                  }}
                  type="submit"
                  form="purchase-plan-filter-form"
                >
                  <Search />
                </StyledButton>
                <StyledButton
                  sx={{
                    background: 'rgb(3, 34, 76)',
                    color: '#fff',
                    '&:hover': {
                      background: 'rgba(3, 34, 76, 0.6)',
                    },
                  }}
                  onClick={handleReset}
                >
                  <Cached />
                </StyledButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  )
}
